module.exports = __webpack_public_path__ + "img/home.3f0cc64f.svg";